import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { RestApiProvider } from '../../providers/rest-api/rest-api';
import { EditcouponPage } from '../editcoupon/editcoupon';

/**
 * Generated class for the RicercacouponPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-ricercacoupon',
  templateUrl: 'ricercacoupon.html',
})
export class RicercacouponPage {
  searchTerm;
  coupons;
  errorMessage;
  constructor(public navCtrl: NavController, 
    public rest: RestApiProvider,
    public navParams: NavParams) {
  }
  setFilteredItems() {
    console.log(this.searchTerm);
    if (this.searchTerm.length > 2) {
      let urlSearchParams  = {
        'name': this.searchTerm,
    };
   // alert(JSON.stringify(urlSearchParams));
      this.rest.searchCoupons(urlSearchParams).subscribe(
        coupons => this.coupons = coupons,
        error => this.errorMessage = <any>error);
      if (this.coupons != null) {
       // alert(JSON.stringify(this.coupons))
       // this.LoadData();
      }
    }
  }
  openEditCouponPage(coupon){
   this.navCtrl.push(EditcouponPage,{coupon:coupon,from:"ricerca"});

  }
 
  ionViewDidLoad() {
    console.log('ionViewDidLoad RicercacouponPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/ricercacoupon/ricercacoupon.ts